import styled from 'styled-components'

import { Section as GSSection, Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, colors, lineHeights, space, fontSizes } = theme

export const Section = styled(GSSection)`
  button {
    justify-content: center;
    width: 100%;
  }

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xl']};
    padding-bottom: ${space['spacing-xl']};

    button {
      justify-content: space-between;
      width: 19rem;
    }
  }

  @media (${media.desktop}) {
    padding-top: 7.5rem;
  }
`

export const DeskImg = styled.span`
  position: relative;
  display: none;
  
  @media (${media.tablet}) {
    display: block;
  }
`

export const MobImg = styled.span`
  position: relative;

  @media (${media.tablet}) {
    display: none;
  }
`

export const Infos = styled(GSInfos)`
  margin-right: ${space['spacing-xxs']};

  p:last-of-type {
    margin-bottom: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    p {
      margin-bottom: ${space['spacing-md']};
      font-size: ${fontSizes['font-size-body-1']};
    }
  }
`

export const List = styled.ul`
  margin-bottom: ${space['spacing-xl']};
`

export const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${space['spacing-md']};
  color: ${colors['neutral-text-weak']};
  line-height: ${lineHeights['font-line-height-lg']};
  font-size: ${fontSizes['font-size-body-1']};

  span {
    position: relative;
    top: -${space['spacing-nano']};
    margin-right: ${space['spacing-xxxs']};
  }
`
